module.exports = __webpack_public_path__ + "assets/img/yesFirstTime.43cd6532.png";